import { render, staticRenderFns } from "./OsobaRazdoblja.vue?vue&type=template&id=67f1b6f4&scoped=true&"
import script from "./OsobaRazdoblja.vue?vue&type=script&lang=js&"
export * from "./OsobaRazdoblja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f1b6f4",
  null
  
)

export default component.exports